import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractPredictionRuleModel from "./AbstractPredictionRuleModel.js";

/**
 * Compute data using the same period from `shift` previous years and
 * compute a growth percentage using linear regression.
 * This prediction rule model is very similar to the FromActualsPredictionRuleModel
 * but the growth percentage is computed and not a user input.
 *
 * For example, if `shift` equals 1 and forecast starts on January
 * 2022:
 *
 * - January 2022 = January 2021 * (100+`growthPercentage`)/100
 * - February 2022 = February 2021 * (100+`growthPercentage`)/100
 * - …
 *
 * If `shift` equals 2 and forecast starts on January 2022:
 *
 * - January 2022 = (January 2021 + January 2020)/2 * (100+`growthPercentage`)/100
 * - February 2022 = (February 2021 + February 2020)/2 * (100+`growthPercentage`)/100
 * - …
 *
 * @param {number} [shift] - Number of previous months
 *   to consider for the regression
 */
export default class SeasonalTrendPredictionRuleModel extends AbstractPredictionRuleModel {
	constructor({ shift = 12 } = {}) {
		super(...arguments);

		this._shift = shift;
	}

	getShift() {
		return this._shift;
	}

	setShift(shift) {
		this._shift = shift;
	}

	accept(visitor) {
		return visitor.visitSeasonalTrendPredictionRuleModel(this);
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.shift = this._shift;
		return properties;
	}

	static getLabel() {
		return _("Seasonal Trend");
	}

	static getType() {
		return "SeasonalTrend";
	}

	static getDescriptionText() {
		return _("Forecast mixing actuals and the linear regression");
	}
}
